import { render, staticRenderFns } from "./OrderListExchangeGoods.vue?vue&type=template&id=5e617bdd&scoped=true"
import script from "./OrderListExchangeGoods.vue?vue&type=script&lang=js"
export * from "./OrderListExchangeGoods.vue?vue&type=script&lang=js"
import style0 from "./OrderListExchangeGoods.vue?vue&type=style&index=0&id=5e617bdd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e617bdd",
  null
  
)

export default component.exports